import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IApiResponse } from '../../../../../shared/models/api-response';
import { IUser } from '../../../../../shared/models/user';
import { AuthService } from '../../../../../shared/services/auth.service';
import { ToastService } from '../../../../../shared/services/toast.service';
import { IDonutChartItem } from '../../../../controls/donut-chart/donut-chart.component';
import { ciFinaliseVoteOption, CiVoteId, IFinaliseCiBallotRequest, CommitteeInternalVoteOption } from '../../../shared/models/ci/ci-vote';
import { BallotCalculationService } from '../../../shared/services/ballot-calculation.service';
import { CiBallotService } from '../../../shared/services/ci-ballot.service';


@Component({
    selector: 'app-cib-finalise-ballot-modal',
    templateUrl: './cib-finalise-ballot-modal.component.html',
    styleUrl: './cib-finalise-ballot-modal.component.scss',
    standalone: false
})
export class CibFinaliseBallotModalComponent implements OnInit, OnDestroy {
  @Input() data: IDonutChartItem[] = [];
  @Input() ballotId: string = '';

  agree = ciFinaliseVoteOption[CiVoteId.AGREE];
  disagree = ciFinaliseVoteOption[CiVoteId.DISAGREE];
  noResponse = ciFinaliseVoteOption[CiVoteId.NO_RESPONSE];
  isNoResponseFull: boolean = false;
  hasMajorityAgree: boolean = false;
  hasMajorityDisagree: boolean = false;
  isVoteTiedForCIBFinalisation: boolean = false;
  ballotData: IDonutChartItem[] = [];
  defaultOption = ciFinaliseVoteOption[CiVoteId.NO_RESPONSE];
  currentUser: IUser | null = null;
  loginUserEmail: string = '';

  ballotForm!: FormGroup;

  finaliseCiBallotRequest: IFinaliseCiBallotRequest = {
    ballotId: '',
    finalisedBy: '',
    resolution: CommitteeInternalVoteOption.NoResponse,
  };

  subscriptions: Subscription = new Subscription();

  constructor(
    public _authService: AuthService,
    public activeModal: NgbActiveModal,
    public ballotCalculationService: BallotCalculationService,
    public _ciBallotService: CiBallotService,
    private _toastService: ToastService
  ) {
    this.initUser();
  }

  ngOnInit(): void {
    this.ballotForm = new FormGroup({
      ballotResponse: new FormControl({
        value: this.agree.name,
        disabled: false,
      }),
    });

    this.checkFinaliseBallotStatus();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

    initUser() {
    const currentUserSubscription = this._authService.currentUserSubject.subscribe((user) => {
      this.currentUser = user;

      if (!this.currentUser) return;
      this.loginUserEmail = this.currentUser.email;
    });

    this.subscriptions.add(currentUserSubscription);
  }

  checkFinaliseBallotStatus() {
    this.ballotData = this.ballotCalculationService.calculatePercentages(
      this.data
    );
    this.isNoResponseFull = this.ballotCalculationService.isNoResponseFull(
      this.ballotData
    );
    this.hasMajorityAgree = this.ballotCalculationService.hasMajorityAgree(
      this.ballotData
    );
    this.hasMajorityDisagree =
      this.ballotCalculationService.hasMajorityDisagree(this.ballotData);
    this.isVoteTiedForCIBFinalisation =
      this.ballotCalculationService.isVoteTiedForCIBFinalisation(
        this.ballotData
      );
    this.defaultOption = this.isNoResponseFull
      ? ciFinaliseVoteOption[CiVoteId.NO_RESPONSE]
      : this.hasMajorityAgree
      ? ciFinaliseVoteOption[CiVoteId.AGREE]
      : ciFinaliseVoteOption[CiVoteId.DISAGREE];
  }

  confirm() {
    this.finaliseCiBallotRequest.ballotId = this.ballotId;
    if(this.isVoteTiedForCIBFinalisation) {
      this.finaliseCiBallotRequest.resolution = this.mapToCommitteeInternalVoteOption(this.ballotForm.value.ballotResponse);
    } else {
      this.finaliseCiBallotRequest.resolution = this.mapToCommitteeInternalVoteOption(this.defaultOption.name);
    }
    if (this.loginUserEmail) {
      this.finaliseCiBallotRequest.finalisedBy = this.loginUserEmail;
    }

    this.subscriptions.add(this._ciBallotService.finaliseBallot(this.ballotId, this.finaliseCiBallotRequest).subscribe({
        next: (response: IApiResponse<any>) => {
          if (response && response.success) {
            this.activeModal.dismiss('cancel');
            this._toastService.showSuccess("Ballot successfully finalised.", 'Committee Internal Ballot');
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        },
        error: (error) => {
          console.error('Inside error callback: ', error);
          this._toastService.showError("Unexpected error occurred. Please try again or contact IT Support.");
        }
      }));
  }
  cancel() {
    this.activeModal.dismiss('cancel');
  }

  mapToCommitteeInternalVoteOption(value: string): CommitteeInternalVoteOption {
  switch (value) {
    case CiVoteId.AGREE:
      return CommitteeInternalVoteOption.Agree;
    case CiVoteId.DISAGREE:
      return CommitteeInternalVoteOption.Disagree;
    case CiVoteId.NO_RESPONSE:
      return CommitteeInternalVoteOption.NoResponse;
    default:
      throw new Error(`Invalid vote option: ${value}`);
  }
}

}
